// Industry-specific quiz templates for multi-tenant system

export const industryTemplates = {
  "Therapist/Mental Health": {
    name: "Therapist/Mental Health",
    branding: {
      primaryColor: "#059669", // Green
      secondaryColor: "#047857",
      gradientFrom: "[#eafaf2]",
      gradientTo: "white",
      buttonColor: "green-600",
      buttonHover: "green-700",
      backgroundColor: "#eafaf2"
    },
    questions: [
      {
        question: "What's the main reason you're considering therapy right now?",
        options: [
          "Feeling stressed/overwhelmed",
          "Anxiety or depression",
          "Relationship issues",
          "Life changes",
          "Personal growth",
          "Other"
        ]
      },
      {
        question: "How would you describe your mood most days?",
        options: [
          "Mostly positive",
          "Up and down",
          "Often anxious or sad",
          "Overwhelmed",
          "Struggling to cope"
        ]
      },
      {
        question: "How much is this challenge affecting your daily life?",
        options: [
          "Slightly",
          "Moderately",
          "Significantly",
          "Severely"
        ]
      },
      {
        question: "What would you most like to achieve through therapy?",
        options: [
          "Better coping skills",
          "Reduced anxiety/stress",
          "Improved relationships",
          "Greater self-understanding",
          "Healing from the past",
          "Feeling more in control"
        ]
      },
      {
        question: "Have you tried therapy before?",
        options: [
          "Yes",
          "No",
          "Briefly"
        ]
      }
    ],
    messaging: {
      title: "Erika Paz",
      subtitle: "Find Relief from Anxiety & Depression with Virtual Sessions in Texas",
      benefits: [
        "Find out if therapy could help you feel better",
        "Get a personalized recommendation for your needs",
        "See if you're a good fit for virtual sessions with Erika",
        "Takes less than 1 minute, no commitment required"
      ],
      resultTitle: "Online therapy is a perfect fit for you!",
      resultSubtitle: "Book a time now and submit your insurance information—all in one simple step. The process is quick and straightforward, so you can get started on the right track.",
      specialties: "Specialties: Anxiety, Bipolar Disorder, Depression, Relationship Issues, Substance Use / Addiction",
      insurance: "Accepts most insurance in TX",
      medicare: "Accepts Medicare and Medicaid",
      bookingUrl: "https://care.headway.co/providers/erika-paz-2?utm_source=pem&utm_medium=direct_link&utm_campaign=130375&fbclid=IwY2xjawLRAyBleHRuA2FlbQIxMABicmlkETF6MTZGd29OdkRUWmtmZVk2AR6IzKa0tU0jF0qHQbgWs9tgpd3OfYQbsaUr8uXKb7lUvprnvcIRyu3RG57JKg_aem_0BcFXrfBMwGmZrwxUUJGag"
    }
  },
  
  realEstate: {
    name: "Real Estate",
    branding: {
      primaryColor: "#059669", // Green
      secondaryColor: "#047857",
      gradientFrom: "green-50",
      gradientTo: "green-200",
      buttonColor: "green-600",
      buttonHover: "green-700"
    },
    questions: [
      {
        question: "How many potential buyers/sellers call but don't reach you each month?",
        options: ["None", "1-3", "4-8", "More than 8"]
      },
      {
        question: "What's the average commission value from a typical transaction?",
        options: ["$2,000-5,000", "$5,000-10,000", "$10,000-15,000", "$15,000+"]
      },
      {
        question: "What's your biggest challenge with missed calls?",
        options: [
          "Lost potential listings",
          "Buyers going to other agents",
          "Missing time-sensitive opportunities",
          "Having to call back constantly"
        ]
      },
      {
        question: "How do you currently handle calls during showings or meetings?",
        options: [
          "Let them go to voicemail",
          "Have an assistant",
          "Try to step away to answer",
          "Use a call forwarding service"
        ]
      },
      {
        question: "How much time do you spend daily returning missed calls?",
        options: ["Less than 30 minutes", "30-60 minutes", "1-2 hours", "More than 2 hours"]
      },
      {
        question: "What CRM or lead management system do you use?",
        options: ["Chime", "Follow Up Boss", "KvCORE", "Other/None"]
      },
      {
        question: "Would you be interested in early access to an instant lead response system?",
        options: ["Very interested", "Somewhat interested", "Maybe", "Not interested"]
      }
    ],
    messaging: {
      title: "Are Missed Calls Costing You Real Estate Commissions?",
      subtitle: "Take our 60-second quiz to see how much you could be losing—and if you qualify for our exclusive early adopter program.",
      benefits: [
        "Never lose another lead to a missed call",
        "Respond to inquiries instantly, even during showings",
        "See your true cost in less than a minute"
      ],
      resultTitle: "Your Real Estate Business Could Be Losing Significant Commissions",
      resultSubtitle: "Based on your answers, our auto-text back app can help you capture more leads, close faster, and never miss an opportunity again."
    }
  }
};

// Default agent configurations
export const defaultAgents = {
  // Erika Paz therapist funnel
  erika: {
    id: "erika",
    name: "Erika Paz",
    industry: "Therapist/Mental Health",
    photo: "https://cdn.abacus.ai/images/74b7b16b-c4f7-4e7a-8b94-2fb3b6076959.png",
    customBranding: null, // Uses industry template
    customQuestions: null, // Uses industry template
    customMessaging: null, // Uses industry template
    active: true,
    createdAt: new Date().toISOString()
  },

  // Real estate demo agent
  realtor123: {
    id: "realtor123",
    name: "Sarah Johnson",
    industry: "realEstate",
    photo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=face",
    customBranding: null, // Uses industry template
    customQuestions: null, // Uses industry template
    customMessaging: null, // Uses industry template
    active: true,
    createdAt: new Date().toISOString()
  },

  // Robbie Hin Roatán real estate funnel
  robbiehin: {
    id: "robbiehin",
    name: "Robbie Hin",
    company: "RE/MAX Roatán Realty",
    industry: "realEstate",
    photo: "https://www.roatan-realestate.com/wp-content/uploads/2025/05/Robbert-Hin-150.webp",
    profileImage: "https://www.roatan-realestate.com/wp-content/uploads/2025/05/Robbert-Hin-150.webp",
    email: "robberthin@gmail.com",
    phone: "+504-3300-0628",
    location: "Roatán, Honduras",
    customFunnel: "roatan",
    customBranding: {
      primaryColor: "#0f766e",
      secondaryColor: "#155e75",
      gradientFrom: "cyan-50",
      gradientTo: "sky-100",
      buttonColor: "cyan-700",
      buttonHover: "sky-800",
      backgroundColor: "#ecfeff"
    },
    customQuestions: null,
    customMessaging: {
      title: "Robbie Hin",
      subtitle: "Find Your Perfect Roatán Property in 60 Seconds",
      benefits: [
        "Beachfront and ocean view opportunities",
        "Buyer and seller guidance tailored to Roatán",
        "Direct follow-up from Robbie within 24 hours"
      ],
      resultTitle: "Thanks for completing the quiz!",
      resultSubtitle: "Robbie Hin of RE/MAX Roatán Realty will personally review your responses and follow up with tailored next steps.",
      bookingUrl: "mailto:robberthin@gmail.com"
    },
    active: true,
    createdAt: new Date().toISOString()
  }
};

// Helper function to get job value for calculations
export function getJobValue(jobValueAnswer, industry = 'Therapist/Mental Health') {
  const valueMap = {
    "Therapist/Mental Health": {
      "$500-1000": 750,
      "$1000-2000": 1500,
      "$2000-3000": 2500,
      "$3000+": 4000
    },
    realEstate: {
      "$2,000-5,000": 3500,
      "$5,000-10,000": 7500,
      "$10,000-15,000": 12500,
      "$15,000+": 20000
    }
  };
  
  return valueMap[industry]?.[jobValueAnswer] || 1000;
}
